import BasicCode from "!!raw-loader!./checkboxes/Basic.tsx";
import LabeledCode from "!!raw-loader!./checkboxes/Labeled.tsx";
import LabeledRTLCode from "!!raw-loader!./checkboxes/LabeledRTL.tsx";
import LabeledWithTooltipCode from "!!raw-loader!./checkboxes/LabeledWithTooltip.tsx";
import WithHelperTextCode from "!!raw-loader!./checkboxes/WithHelperText.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Basic from "./checkboxes/Basic";
import Labeled from "./checkboxes/Labeled";
import LabeledRTL from "./checkboxes/LabeledRTL";
import LabeledWithTooltip from "./checkboxes/LabeledWithTooltip";
import WithHelperText from "./checkboxes/WithHelperText";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Basic", BasicCode, Basic),
		paneComponent("Labeled", LabeledCode, Labeled),
		paneComponent("Labeled RTL", LabeledRTLCode, LabeledRTL),
		paneComponent("Labeled With Tooltip", LabeledWithTooltipCode, LabeledWithTooltip),
		paneComponent("With Main Text and helper text", WithHelperTextCode, WithHelperText),
	];

	return (
		<Pane
			components={components}
			imports={"import {Checkbox} from \"designSystem/index\";"}
			muiApi="checkbox"
			muiComponent="checkboxes"
			{...props}
		/>
	);
};